import styles from './icon.module.css';

interface IProps {
  iconUrl: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  className?: string;
  iconWidth?: number;
  iconHeight?: number;
  style?: React.CSSProperties;
  onClick?: (e?: React.MouseEvent<SVGSVGElement | HTMLDivElement>) => void;
  fill?: boolean;
}

const LinkIcon = (props: IProps) => {
  const {
    iconUrl: IconComponent,
    iconWidth,
    iconHeight,
    className,
    onClick,
    fill
  } = props;
  return (
    <>
      {typeof IconComponent !== 'string' ? (
        <IconComponent
          className={`${styles.linkIcon} ${String(className)} ${
            fill ? styles.fillIcon : ''
          }`}
          style={{
            width: `${Number(iconWidth)}px`,
            height: `${Number(iconHeight)}px`
          }}
          onClick={onClick}
          aria-hidden="true"
        ></IconComponent>
      ) : (
        <img
          src={IconComponent}
          alt=""
          loading="lazy"
          className={`${styles.imgIcon} ${String(className)}`}
          style={{
            width: `${Number(iconWidth)}px`,
            height: `${Number(iconHeight)}px`
          }}
          onClick={onClick}
        />
      )}
    </>
  );
};
export default LinkIcon;
